import { z } from "zod"

export const BOX_OFFER_TICKET_BOOKS_MIN = 1
export const BOX_OFFER_TICKET_BOOKS_MAX = 99
export const BOX_OFFER_WEEKLY_PARTICIPATION_MIN = 1
export const BOX_OFFER_WEEKLY_PARTICIPATION_MAX = 99
export const BOX_OFFER_VALIDITY_MIN = 1
export const BOX_OFFER_VALIDITY_MAX = 24

export enum BoxOfferType {
  Subscription = "SUBSCRIPTION",
  DropIn = "DROP_IN",
  Trial = "TRIAL",
  TicketsBook = "TICKETS_BOOK",
  Millenium = "MILLENIUM",
}

export enum BoxOfferLiteVersion {
  DropIn = "DROP_IN",
  Trial = "TRIAL",
  Millenium = "MILLENIUM",
}

export enum BoxOfferPriceType {
  Free = "FREE",
  Paid = "PAID",
}

export enum BoxOfferWeeklyParticipationType {
  Unlimited = "UNLIMITED",
  Restricted = "RESTRICTED",
}

export enum BoxOfferAutonomousPurchase {
  NO_ONE = "NO_ONE",
  MEMBERS = "MEMBERS",
  LEADS_AND_DROP_IN = "LEADS_AND_DROP_IN",
  PUBLIC = "PUBLIC",
}

export enum BoxOfferInvitationStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REFUSED = "REFUSED",
  CANCELLED = "CANCELLED",
}

export enum BoxOfferRulePeriod {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
}

export const BoxOfferRuleSchema = z.object({
  value: z.number(),
  period: z.nativeEnum(BoxOfferRulePeriod),
})

export type BoxOfferRule = z.infer<typeof BoxOfferRuleSchema>

export enum BoxOfferValidity {
  UNLIMITED = "UNLIMITED",
  DEFINED = "DEFINED",
}

export type LightBoxOfferInfo = {
  id: string
  name: string
  price: Price
  type: BoxOfferType
}

export type Price = {
  value: number
  currency: string
}

export const BoxOfferInvitationLinkSchema = z.object({
  boxId: z.string(),
  boxOfferId: z.string(),
  shortLink: z.string(),
})

export type BoxOfferInvitationLink = z.infer<typeof BoxOfferInvitationLinkSchema>
